import React from "react";
import { IPlanRecurrency } from "~/types/types";
import { Button } from "@govlaunch/core";
import * as palette from "@govlaunch/palette";
import { FormattedMessage } from "react-intl";

interface IChangePlanOptionPriceProps {
  price: number;
  recurrency?: IPlanRecurrency;
  name: string;
}

export default function ChangePlanOptionPrice({ price, recurrency, name }: IChangePlanOptionPriceProps) {
  if (name === "Makers Pro") {
    return (
      <Button
        size="large"
        theme="primary"
        color={palette.primary}
        textColor={palette.white}
        css={{ width: "90%", justifySelf: "center" }}
        data-intercom-target="ContactUsForMakersPro"
      >
        <FormattedMessage defaultMessage="Contact Us" id="hZOGLS" />
      </Button>
    );
  }

  if (price === 0) {
    return (
      <strong
        css={{
          padding: 20,
          fontWeight: 600,
          fontSize: 20,
          textAlign: "center",
        }}
      >
        <FormattedMessage defaultMessage="Free" id="tf1lIh" />
      </strong>
    );
  }

  return (
    <strong
      css={{
        padding: 20,
        fontWeight: 600,
        fontSize: 20,
        textAlign: "center",
      }}
    >
      ${recurrency === IPlanRecurrency.Monthly ? priceWithDecimals(price / 100) : priceWithDecimals(price / 100 / 12)} /{" "}
      <FormattedMessage defaultMessage="month" id="Cu3Cty" />
    </strong>
  );
}

function priceWithDecimals(price: number) {
  if (price !== Math.floor(price)) {
    return price.toFixed(2);
  } else {
    return price;
  }
}
